import React from 'react';

const BotListLoading: React.FC = () => {
  return (
    <div
        style={{
          backgroundColor: 'var(--tint)',
          borderRadius: '20px',
          padding: '40px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'Montserrat',
          fontSize: '20px',
          fontWeight: 500,
          color: 'var(--primary)',
          textAlign: 'center',
          margin: '20px auto',
        }}
  >
      <p style={{ margin: 0 }}>
        Loading your bots...
      </p>
    </div>
  );
};

export default BotListLoading;
